<template>
    <div class="body_div">
        <div class="content_div">
            <div class="top_card">
                <div class="top_button" style="font-size: 28px;color: black;">毕业论文管理系统</div>
                <div @click="goLogin" class="top_button">去登录</div>
            </div>
            <el-card>
                <el-form :model="data" :rules="rules" ref="data" label-width="100px" class="demo-ruleForm">
                    <div>
                        <el-form-item label="登录名" prop="userName">
                            <el-input maxlength="30" v-model="data.userName"></el-input>
                        </el-form-item>
                        <el-form-item label="昵称" prop="nickName">
                            <el-input maxlength="10" v-model="data.nickName"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号" prop="phone">
                            <el-input maxlength="11" v-model="data.phone"></el-input>
                        </el-form-item>
                        <el-form-item label="密码" prop="password">
                            <el-input maxlength="20" v-model="data.password"></el-input>
                        </el-form-item>
                    </div>
                    <div style="display: flex;justify-content: center;align-items: center;">
                        <el-form-item>
                            <el-button style="width: 200px;" type="primary" @click="submitRegister('data')">快速注册</el-button>
                        </el-form-item>
                    </div>
                </el-form>
            </el-card>
        </div>
    </div>
</template>
<script>
import {reqRegisterUser} from "@/api/Users";

export default {
    name: "Register",
    created() {
    },
    methods: {
        goLogin() {
            this.$router.push("/login");
        },
        goIndex() {
            this.$router.push("/");
        },
        async submitRegister(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    let {data} = await reqRegisterUser(this.data);
                    console.log(data);
                    this.$message.success("注册成功！");
                    this.goLogin();
                } else {
                    return false;
                }
            });
        },
    },
    data() {
        return {
            total: 0,
            dataList: [],
            query: {},
            data: {
                userName: "",
                phone: "",
                nickName: "",
                password: "",
                avatar: "",
            },
            rules: {
                userName: [
                    {required: true, message: '请输入用户名', trigger: 'blur'}
                ],
                phone: [
                    {
                        required: true, message: '请输入手机号', trigger: 'blur'
                    }],
                nickName: [
                    {
                        required: true, message: '请输入昵称', trigger: 'blur'
                    }],
                password: [
                    {
                        required: true, message: '请输入密码', trigger: 'blur'
                    }],
            }
        }
    }
}
</script>
<style scoped lang="scss">
.content_div {
    justify-content: center;
    width: 25%;
    position: absolute;
    top: 30%;
    left: 35%;
}

.top_button {
    cursor: pointer;
}

.body_div {
    //background-image: url("@/assets/bg.jpg");
    width: 100%;
    height: 100vh;
    //background-color: #92a8a9;
}

.top_card {
    background-color: #77b9be;
    color: white;
    height: 50px;
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 10px 30px;
}
</style>
